import React from 'react'
import { Trans, t } from '@lingui/macro'

import {
  TopicModelAsEditor,
  TopicVersionType
} from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { usePatchDraftMutation } from './operations/patchDraft.codegen'
import { useTopicForEditQuery } from 'front-end/src/pages/topic-edit-page/TopicEditPage'
import IconShuffle from '../../../../components/common/icon/IconShuffle'
import {
  Select,
  DrawerItem,
  DrawerItemHeader,
  Spinner
} from 'front-end/src/components'

const options = [
  {
    label: t`Page format`,
    value: TopicVersionType.s
  },
  {
    label: t`Slides format`,
    value: TopicVersionType.m
  }
]

const SetTopicVersionType = () => {
  const [patchDraft] = usePatchDraftMutation()
  const { data, loading } = useTopicForEditQuery()

  if (loading) {
    return <Spinner />
  }

  const topic = data?.topic as TopicModelAsEditor
  if (
    topic?.draftVersion?.topic_type !== TopicVersionType.m &&
    topic?.draftVersion?.topic_type !== TopicVersionType.s
  ) {
    return null
  }

  return (
    <DrawerItem>
      <DrawerItemHeader dataTest="ResourceStyleDrawer">
        <IconShuffle />
        <Trans>Resource style</Trans>
      </DrawerItemHeader>

      <Select
        options={options}
        data-test="SetTopicType__select"
        value={options.find(({ value }) => {
          return value === topic.draftVersion?.topic_type
        })}
        onChange={async (v) => {
          await patchDraft({
            variables: {
              topicId: topic.id,
              input: {
                topic_type: v?.value
              }
            }
          })
          window.location.reload() //TODO once we have a the whole topic in react context or apollo, we should remove this and be able to just call `refetch()` or `updateTopicType()`
        }}
      >
        <option value={TopicVersionType.s}>{t`Page format`}</option>
        <option value={TopicVersionType.m}>{t`Slides format`}</option>
      </Select>
    </DrawerItem>
  )
}

export default SetTopicVersionType
